module.exports = __webpack_public_path__ + "ce97da9248f8af331562a3389e80e128.pdf";